import { set_discount, set_discount_code } from '../confg';
import { createAction } from '@reduxjs/toolkit';

export const set_discount_action = createAction(set_discount);
export const set_discount_code_action = createAction(set_discount_code);
